import * as React from "react";
function SvgArrowUp(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#arrow-up_svg__clip0_2_3110)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.707 10.3l-7-7a1 1 0 00-1.414 0l-7 7 1.414 1.414L11 6.421v14.586h2V6.421l5.293 5.293 1.414-1.414z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="arrow-up_svg__clip0_2_3110">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgArrowUp);
export default ForwardRef;
